import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import collegedegreeServices from './collegedegree.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getCollegeDegree = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COLLEGE_DEGREE,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};

    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Titulo/' : '/api/app/Funcional_Titulo/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await collegedegreeServices.getCollegedegrees(params, iType);
    dispatch({
      type: actions.GET_COLLEGE_DEGREE,
      payload: {
        collegeDegree: resp.data.data,
        collegeDegreeLength: resp.data.count
      }
    });
    dispatch({
      type: actions.COLLEGE_DEGREE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.COLLEGE_DEGREE_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_COLLEGE_DEGREE,
      payload: false
    });
  }
}

export const saveCollegeDegree = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COLLEGE_DEGREE,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Titulo/' : '/api/app/Funcional_Titulo/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await collegedegreeServices.saveCollegedegree(req, iType);
    const { collegeDegree, collegeDegreeLength } = getState().collegeDegree;
    const aCollegeDegree = [...collegeDegree, resp.data];
    dispatch({
      type: actions.GET_COLLEGE_DEGREE,
      payload: {
        collegeDegree: aCollegeDegree,
        collegeDegreeLength: collegeDegreeLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_COLLEGE_DEGREE,
      payload: false
    });
  }
}

export const editCollegeDegree = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COLLEGE_DEGREE,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Titulo/${id}/` : `/api/app/Funcional_Titulo/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await collegedegreeServices.editCollegedegree(id, req, iType);
    const { collegeDegree, collegeDegreeLength } = getState().collegeDegree;
    collegeDegree[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_COLLEGE_DEGREE,
      payload: {
        collegeDegree: collegeDegree,
        collegeDegreeLength: collegeDegreeLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_COLLEGE_DEGREE,
      payload: false
    });
  }
}

export const deleteCollegeDegree = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COLLEGE_DEGREE,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Titulo/${id}/` : `/api/app/Funcional_Titulo/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await collegedegreeServices.deleteCollegedegree(id, iType);
    const { collegeDegree, collegeDegreeLength } = getState().collegeDegree;
    collegeDegree.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_COLLEGE_DEGREE,
      payload: {
        collegeDegree: collegeDegree,
        collegeDegreeLength: collegeDegreeLength -1
      }
    });
    dispatch({
      type: actions.COLLEGE_DEGREE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.COLLEGE_DEGREE_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_COLLEGE_DEGREE,
      payload: false
    });
  }
}
